import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "completion-highlight__open iconfont inext",
  "aria-hidden": "true"
}

import { computed, onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CompletionHighlight',
  props: {
    quote: {}
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const passage = ref<HTMLElement | null>(null)
const expanded = ref(false)
const overflows = ref(false)
const canExpand = computed(() => overflows.value && !expanded.value)

onMounted(() => {
  // Offer the nested expander only when the five-line clamp hides text.
  if (passage.value) {
    overflows.value = passage.value.scrollHeight > passage.value.clientHeight
  }
})

function openIfFullyVisible(): void {
  if (!canExpand.value) {
    emit('open')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["completion-highlight", { 'completion-highlight--clickable': !canExpand.value }]),
    onClick: openIfFullyVisible
  }, [
    (canExpand.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "completion-highlight__open iconfont inext",
          type: "button",
          "aria-label": "Open highlight",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('open')), ["stop"]))
        }))
      : (_openBlock(), _createElementBlock("span", _hoisted_1)),
    _createElementVNode("p", {
      ref_key: "passage",
      ref: passage,
      class: _normalizeClass(["completion-highlight__passage", { 'completion-highlight__passage--clamped': !expanded.value }])
    }, _toDisplayString(__props.quote), 3),
    (canExpand.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "completion-highlight__more",
          type: "button",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (expanded.value = true), ["stop"]))
        }, " Show more "))
      : _createCommentVNode("", true)
  ], 2))
}
}

})